<template>
  <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      class="CreateDeliveryBillDialog"
      title="创建送货单"
      width="90%"
      top="1vh">
    <el-button type="primary" style="margin-top: -30px; margin-right: 30px" @click="addRow">增加行项</el-button>
    <vm-search label="送货时间">
      <el-date-picker
          v-model="createData.plannedArrivalTime"
          value-format="yyyy-MM-dd 00:00:00"
          type="date"
          style="width: 150px"/>
    </vm-search>
    <el-button type="danger" style="float: right" @click="deleteAllRow">清空</el-button>
    <el-table :data="createData.receiveDetails" height="45vh">
      <el-table-column prop="evaluate" align="center" label="采购单" width="100"/>
      <el-table-column prop="podetailRowNO" align="center" label="行号" width="70"/>
      <el-table-column prop="sapmaterialNO" align="center" label="物料号" width="90"/>
      <el-table-column prop="sapmaterialName" align="center" label="物料描述" show-overflow-tooltip/>
      <el-table-column prop="requireDeliveryDate" align="center" label="交货期" width="150"/>
      <el-table-column prop="sumQuantity" align="center" label="数量" width="70"/>
      <el-table-column prop="hasReceiveQty" align="center" label="已送数量" width="70"/>
      <el-table-column prop="quantity" align="center" label="本次送货数量" width="110">
        <template slot-scope="scope">
          <el-input v-model.trim="scope.row.quantity" @change="checkNum(scope.row)"/>
        </template>
      </el-table-column>
      <el-table-column prop="note" align="center" label="备注" width="300">
        <template slot-scope="scope">
          <el-input v-model.trim="scope.row.note"/>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" class-name="vm-table_operate" width="80">
        <template slot-scope="scope">
          <el-button type="danger" @click="deleteRow(scope.$index)">移除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-button type="primary" style="margin: 10px 0 10px 90%" :loading="submitLoading" @click="submit">提交</el-button>
  </el-dialog>
</template>

<script>
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    name: "CreateDeliveryBillDialog",
    components: {VmSearch},
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        pkid: null,
        filter: {
          purchaseOrderNO: "",
          partNO: "",
          qty: "",
          deliveryDateBegin: "",
          deliveryDateEnd: "",
          isFinished: 1,
        },
        selectedRow: [],
        createData: {
          pkid: null,
          plannedArrivalTime: "",
          receiveDetails: [],
        },
      };
    },
    methods: {
      open(pkid) {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
          if (pkid) {
            this.pkid = pkid;
            this.getData();
          }
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      getData() {
        this.$http.get("basic", "purchaseReceives/getPurchaseReceiveById/" + this.pkid).then((resp) => {
          this.createData.pkid = resp.pkid;
          this.createData.plannedArrivalTime = resp.plannedArrivalTime;
          this.createData.receiveDetails = resp.receiveDetails;
        });
      },
      checkNum(row) {
        if (row.quantity <= 0) {
          row.quantity = row.qty - row.hasReceiveQty;
          return this.$message.error("送货数量应大于0");
        }
        if (row.quantity > row.qty - row.hasReceiveQty) {
          row.quantity = row.qty - row.hasReceiveQty;
          return this.$message.error("送货数量超时剩余未发数量");
        }
      },
      submit() {
        if (!this.createData.plannedArrivalTime) {
          return this.$message.error("请选择送货时间");
        }
        if (this.createData.receiveDetails.length == 0) {
          return this.$message.error("请选择送货行项");
        }
        for (let item of this.createData.receiveDetails) {
          if (item.quantity < 1) {
            return this.$message.error("送货数量不能小于1");
          }
        }
        this.submitLoading = true;
        if (this.pkid > 0) {
          this.$http
            .post("basic", "purchaseReceives/update", this.createData)
            .then(() => {
              this.submitLoading = false;
              this.dialogVisible = false;
              this.$emit("save-success");
              this.$message.success("修改成功");
            })
            .catch(() => {
              this.submitLoading = false;
            });
        } else {
          let id = 0;
          this.$http
            .post("basic", "purchaseReceives/create", this.createData)
            .then((res) => {
              this.submitLoading = false;
              this.dialogVisible = false;
              this.$emit("save-success");
              this.$message.success("保存成功");
              id = res;
              this.$http.get("basic", `purchaseReceives/updateNo/${id}`);
            })
            .catch(() => {
              this.submitLoading = false;
            });

        }
      },
      addRow() {
        for (let itemO of this.selectedRow) {
          let flag = true;
          for (let itemI of this.createData.receiveDetails) {
            if (itemO.pkid == itemI.pkid) {
              flag = false;
            }
          }
          if (flag && itemO.qty - itemO.hasReceiveQty > 0) {
            this.createData.receiveDetails.push({
              pkid: itemO.pkid,
              purchaseOrderId: itemO.mastPKID,
              purchaseDetailId: itemO.pkid,
              evaluate: itemO.evaluate,
              supplierNo: itemO.supplierNo,
              supplierName: itemO.supplierName,
              podetailRowNO: itemO.rowNum,
              sapmaterialNO: itemO.partNo,
              sapmaterialName: itemO.partNameSpec,
              requireDeliveryDate: itemO.deliveryDate,
              sumQuantity: itemO.qty,
              hasReceiveQty: itemO.hasReceiveQty,
              note: "",
              quantity: itemO.qty - itemO.hasReceiveQty,
            });
          }
        }
        console.log(this.createData.receiveDetails);
      },
      deleteRow(index) {
        this.createData.receiveDetails.splice(index, 1);
      },
      deleteAllRow() {
        this.createData.receiveDetails = [];
      },
      select(selection) {
        this.selectedRow = selection;
      },
    },
  };
</script>

<style lang="scss">
.CreateDeliveryBillDialog {
  .el-dialog .el-dialog__body {
    padding: 2px 10px 10px 10px;
  }
}
</style>
